<template>
  <div class="user-upsert">
    <KTCodePreview v-bind:title="title">
      <template v-slot:preview>
        <b-row>
          <b-col md="3">
            <b-form-group
              label="Tên tài khoản:"
              label-class="font-weight-bold"
              class="required-control"
              label-for="#"
              :state="validState('userForm.username')"
              :invalid-feedback="getInvalidFeedback($v.userForm.username)"
            >
              <b-input
                size="sm"
                single-line
                class="input-style text-left"
                placeholder="Nhập tên tài khoản"
                v-model.trim="$v.userForm.username.$model"
                :class="{ 'is-invalid': $v.userForm.username.$error }"
                :disabled="isMode(['update', 'view'])"
                @input="onInputChange"
              />
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group
              label="Mật khẩu:"
              label-class="font-weight-bold"
              class="required-control"
              label-for="#"
              :description="
                isMode('create')
                  ? 'Có thể xem mật khẩu khi tạo mới'
                  : isMode('update')
                  ? 'Tạo mật khẩu mới khi cập nhật'
                  : ''
              "
            >
              <b-input-group size="sm">
                <b-input
                  size="sm"
                  single-line
                  placeholder="Tạo mật khẩu tự động"
                  class="input-style text-left"
                  :type="isTypeChange ? 'text' : 'password'"
                  v-model="userForm.password"
                  :disabled="true"
                />
                <b-input-group-append v-if="isMode(['create', 'update'])">
                  <b-button variant="secondary" @click="onClickAppendPassword">
                    <span v-if="isMode('create')">
                      <i
                        class="fa-regular ml-1"
                        style="width: 20px"
                        :class="isTypeChange ? 'fa-eye-slash' : 'fa-eye'"
                      ></i>
                    </span>
                    <span v-if="isMode('update')">
                      <i class="fa-solid fa-rotate ml-1" style="width: 20px"></i>
                    </span>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3">
            <b-form-group
              label="Nhân sự:"
              label-class="font-weight-bold"
              class="required-control"
              label-for="#"
            >
              <Autosuggest
                :suggestions="optionsEmployee"
                :model="userForm.employeeName"
                :placeholder="'nhân sự'"
                @change="onChange($event, 'employee')"
                @select="onSelected($event, 'employee')"
                :state="validState('userForm.employeeId')"
                :limit="10"
                :disabled="isMode('view')"
                errorMessages="Yêu cầu chọn nhân sự."
                suggestionName="fullName"
              >
                <template #custom="{ suggestion }">
                  <div>
                    <span>{{ suggestion.item.fullName }}</span>
                    <span class="text-primary" v-if="suggestion.item.code">
                      - {{ suggestion.item.code }}
                    </span>
                  </div>
                </template>
              </Autosuggest>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group
              label="Chọn quyền:"
              label-class="font-weight-bold"
              class="required-control"
              label-for="#"
            >
              <Autosuggest
                :suggestions="optionsRole"
                :model="userForm.roleName"
                :placeholder="'quyền'"
                :limit="10"
                :disabled="isMode('view')"
                @change="onChange($event, 'role')"
                @select="onSelected($event, 'role')"
                :state="validState('userForm.roleId')"
                errorMessages="Yêu cầu chọn quyền."
                suggestionName="name"
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group
              label="Trạng thái:"
              label-class="font-weight-bold"
              class="required-control"
              label-for="#"
            >
              <b-form-select
                v-model="userForm.isActive"
                class="select-style"
                size="sm"
                :options="optionsStatus"
                value-field="id"
                text-field="name"
                disabled-field="notEnabled"
                :state="validState('userForm.isActive')"
                :disabled="isMode('view')"
              >
              </b-form-select>
              <b-form-invalid-feedback>
                Vui lòng chọn trạng thái
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Section giới hạn ngày — chỉ hiện khi update hoặc view -->
        <div v-if="isMode(['update', 'view'])" class="mt-4">
          <hr />
          <h6 class="font-weight-bold mb-1">Giới hạn ngày xem / chỉnh sửa (cá nhân)</h6>
          <p class="text-muted mb-3" style="font-size: 12px">
            Để trống = kế thừa từ chức vụ. Nhập số ngày để áp dụng riêng cho tài khoản này.
          </p>
          <div v-if="dayLimitLoading" class="py-3 text-center text-muted">
            Đang tải cấu hình...
          </div>
          <DayLimitMatrix
            v-else
            v-model="dayLimitConfigs"
            :fallback-value="dayLimitJobTitleConfigs"
            :readonly="isMode('view')"
          />
        </div>
      </template>

      <template v-slot:foot>
        <div>
          <b-button
            v-if="isMode(['update', 'create'])"
            class="font-weight-bolder button-width"
            variant="primary"
            size="sm"
            :disabled="isBusy"
            @click="upsertUser"
            >{{ mode[currentMode].titleBtn }}</b-button
          >
          <b-button
            class="button-width font-weight-bolder ml-2"
            variant="secondary"
            size="sm"
            @click="$router.go(-1)"
            >Hủy</b-button
          >
        </div>
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import ApiService from '@/core/services/api.service';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import { mapGetters } from 'vuex';
import { checkPermission } from '@/utils/permission';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import { validationMixin } from 'vuelidate';
import { minLength, maxLength, required } from 'vuelidate/lib/validators';
import {
  makeToastFaile,
  makeToastSuccess,
  xoa_dau,
  cloneDeep,
  removeAccents,
  handleError,
} from '@/utils/common';
import debounce from 'debounce';
import DayLimitMatrix from '@/view/components/DayLimitMatrix.vue';

export default {
  mixins: [validationMixin],
  components: {
    KTCodePreview,
    Autosuggest,
    DayLimitMatrix,
  },
  data() {
    return {
      title: 'Tạo mới tài khoản',
      mode: {
        update: { title: 'Cập nhật tài khoản', titleBtn: 'Cập nhật' },
        create: { title: 'Tạo mới tài khoản', titleBtn: 'Tạo mới' },
        view: { title: 'Thông tin tài khoản' },
      },
      currentMode: '',
      userId: null,
      optionsEmployee: [],
      optionsStatus: [],
      optionsRole: [],
      searchEmployee: null,
      optionOrigin: {},
      userForm: {
        id: null,
        username: null,
        employeeId: null,
        employeeName: null,
        password: null,
        roleId: null,
        roleName: null,
        isActive: 1,
      },
      isExistUsername: true,
      isTypeChange: false,
      isRenewPassword: false,
      isBusy: false,

      // day limit
      dayLimitConfigs: {},
      dayLimitOriginal: {},
      dayLimitJobTitleConfigs: {},
      dayLimitLoading: false,
    };
  },
  validations: {
    userForm: {
      username: {
        required,
        regex(value) {
          return /^[a-zA-Z0-9_.]+$/.test(value);
        },
        minLength: minLength(3),
        maxLength: maxLength(100),
        isExist() {
          return this.isExistUsername;
        },
      },
      employeeId: { required },
      roleId: { required },
      isActive: { required },
    },
  },
  computed: {
    ...mapGetters(['listPermission']),
  },
  created() {
    this.userId = this.$route.query.id || null;
    this.currentMode = this.getMode();
    this.title = this.mode[this.currentMode].title;

    switch (this.currentMode) {
      case 'update':
        this.getUserById(this.userId);
        this.fetchRoles();
        this.fetchEmployees();
        this.fetchDayLimitConfigs(this.userId);
        break;
      case 'create':
        this.generatePassword();
        this.fetchRoles();
        this.fetchEmployees();
        this.userForm.actionMode = 1;
        break;
      case 'view':
        this.getUserById(this.userId);
        this.fetchDayLimitConfigs(this.userId);
        break;
    }

    this.optionsStatus.push(
      { id: 1, name: 'Hoạt động' },
      { id: 2, name: 'Đang Khóa' },
    );

    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Tài khoản', route: '/users' },
      { title: 'Danh sách tài khoản', route: '/users' },
      { title: this.mode[this.currentMode].title },
    ]);
  },
  methods: {
    checkPermission,
    getMode() {
      return this.userId && this.checkPermission(this.listPermission, 'USER_UPDATE')
        ? 'update'
        : this.checkPermission(this.listPermission, 'USER_INSERT')
        ? 'create'
        : 'view';
    },
    isMode(param) {
      if (Array.isArray(param)) return param.includes(this.currentMode);
      return this.currentMode === param;
    },
    validState(fieldname) {
      if (typeof fieldname !== 'string') throw new Error('fieldname should be string');
      const splitData = fieldname.split('.');
      const [model] = splitData;
      if (!model) throw new Error('Model can not be empty');
      if (!this.$v[model]) throw new Error(`${model} not declared in validations`);
      if (this.$v[model] && this.$v[model][splitData[1]]) {
        const { $dirty, $error } = this.$v[model][splitData[1]];
        return $dirty ? !$error : null;
      }
    },
    getInvalidFeedback(validation) {
      if (!validation.$dirty) return '';
      if (!validation.minLength) return 'Tên tài khoản tối thiểu 3 ký tự';
      if (!validation.required) return 'Vui lòng nhập tên đăng nhập';
      if (!validation.isExist) return 'Tài khoản đã tồn tại trong hệ thống';
      if (!validation.regex) return 'Tên tài khoản chỉ được chứa kí tự (_.)';
      if (!validation.maxLength) return 'Tên tài khoản quá dài';
      return '';
    },
    catchAnyError(model) {
      this.$v[model].$touch();
      return this.$v[model].$anyError;
    },
    async upsertUser() {
      if (this.catchAnyError('userForm')) return;
      if (this.isBusy) return;
      this.isBusy = true;
      const method = this.userId ? 'put' : 'post';
      try {
        const { data } = await ApiService[method]('v1/users', { ...this.userForm });
        if (this.currentMode === 'update' && this.hasDayLimitChanged()) {
          await this.saveDayLimitConfigs(this.userId);
        }
        makeToastSuccess(data.message);
        this.$router.push({ path: '/users' });
      } catch (err) {
        makeToastFaile(err.response?.data?.message || 'Có lỗi xảy ra');
      } finally {
        this.isBusy = false;
      }
    },
    hasDayLimitChanged() {
      return JSON.stringify(this.dayLimitConfigs) !== JSON.stringify(this.dayLimitOriginal);
    },
    fetchRoles: async function () {
      this.optionsRole = [];
      ApiService.get('v1/roles/all').then((response) => {
        const roles = response.data.data;
        this.optionOrigin.optionsRole = cloneDeep(roles);
        this.optionsRole = roles;
      });
    },
    getUserById: function (userId) {
      if (!userId) throw new Error('Yêu cầu userId');
      ApiService.get(`v1/users/${userId}`)
        .then((response) => {
          this.userForm = Object.assign(this.userForm, response.data.data);
        })
        .catch((err) => {
          makeToastFaile(err.response?.data?.message);
        });
    },
    fetchEmployees: async function () {
      ApiService.get('v1/employees/all').then((response) => {
        const listEmployee = response.data.data;
        const optionsEmployee = listEmployee.map((item) => {
          const nameNoneSign = xoa_dau(item.fullName);
          return { id: item.id, fullName: nameNoneSign, nameNoneSign, code: item.code };
        });
        this.optionsEmployee = optionsEmployee;
        this.optionOrigin.optionsEmployee = cloneDeep(optionsEmployee);
      });
    },
    fetchDayLimitConfigs: async function (userId) {
      this.dayLimitLoading = true;
      try {
        const { data } = await ApiService.get(`v1/day-limit-configs/users/${userId}`);
        const toMap = configs =>
          (configs || []).reduce((acc, item) => {
            acc[item.featureKey] = { viewDays: item.viewDays, editDays: item.editDays };
            return acc;
          }, {});
        const userMap = toMap(data.data.userConfigs);
        this.dayLimitConfigs = userMap;
        this.dayLimitOriginal = cloneDeep(userMap);
        this.dayLimitJobTitleConfigs = toMap(data.data.jobTitleConfigs);
      } catch (error) {
        handleError(error);
      } finally {
        this.dayLimitLoading = false;
      }
    },
    saveDayLimitConfigs: async function (userId) {
      const configs = Object.entries(this.dayLimitConfigs).map(([featureKey, val]) => ({
        featureKey,
        viewDays: val.viewDays ?? null,
        editDays: val.editDays ?? null,
      }));
      await ApiService.put(`v1/day-limit-configs/users/${userId}`, { configs });
    },
    onSelected(option, type) {
      switch (type) {
        case 'employee':
          this.userForm.employeeId = option.item.id;
          this.userForm.employeeName = option.item.fullName;
          break;
        case 'role':
          this.userForm.roleId = option.item.id;
          this.userForm.roleName = option.item.name;
          break;
      }
    },
    onChange(textInput = '', type) {
      switch (type) {
        case 'employee':
          this.userForm.employeeId = null;
          this.optionsEmployee = this.fitlerOptionsBy(
            this.optionOrigin.optionsEmployee, textInput, 'fullName', 10,
          );
          break;
        case 'role':
          this.userForm.roleId = null;
          this.optionsRole = this.fitlerOptionsBy(
            this.optionOrigin.optionsRole, textInput, 'name', 10,
          );
          break;
      }
    },
    fitlerOptionsBy(items, textInput, prop, limit) {
      return cloneDeep(items)
        .filter((item) => {
          if (!item) return false;
          const nameWTUnicode = removeAccents(item[prop] || '');
          const nameInputWTUnicode = removeAccents(textInput);
          return nameWTUnicode.toLowerCase().indexOf(nameInputWTUnicode.toLowerCase()) > -1;
        })
        .slice(0, limit);
    },
    onInputChange(username) {
      this.isExistUsername = true;
      const usernameCheck = username ? username.trim() : '';
      if (!usernameCheck || usernameCheck.length < 4) return;
      this.debounceInput(username);
    },
    debounceInput: debounce(function (textSearch) {
      this.checkUsername(textSearch);
    }, 1000),
    checkUsername(username) {
      ApiService.query('v1/users/check', { params: { username } })
        .then((response) => {
          this.isExistUsername = response.data.data ? false : true;
        })
        .catch((err) => {
          makeToastFaile(err.response?.data?.message);
        });
    },
    generatePassword() {
      ApiService.get('v1/users/password/generate')
        .then((response) => {
          this.userForm.password = response.data.data;
        })
        .catch((err) => {
          makeToastFaile(err.response?.data?.message);
        });
    },
    onClickAppendPassword() {
      if (this.isMode('create')) {
        this.isTypeChange = !this.isTypeChange;
        return;
      }
      if (this.isMode('update')) {
        this.generatePassword();
        this.isRenewPassword = true;
      }
    },
  },
};
</script>

<style scoped>
.button-width {
  width: 100px;
}
</style>
